module.exports = __webpack_public_path__ + "static/media/145.821bbc50.webp";